import { SubPageShell } from "@/components/SubPageShell";
import { Gallery } from "@/components/Gallery";

export default function GalleryPage() {
  return (
    <SubPageShell
      eyebrow="Full Gallery"
      title={<>Every corner of <em>Ata House.</em></>}
      intro="A complete photo journey through the house, the deck, the pool and the gardens. Tap any image to view it full size."
    >
      <Gallery hideHeader />
    </SubPageShell>
  );
}
